import zenObservable from 'zen-observable';

var Observable = zenObservable;

export default Observable;
export { Observable };
//# sourceMappingURL=bundle.esm.js.map



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/zen-observable-ts/lib/bundle.esm.js
// module id = J0Zc
// module chunks = 0